import React from 'react'
import PrivacyPolicy from '../components/screens/PrivacyPolicy'

export default function PrivacyPolicyContainer() {

  return <PrivacyPolicy />
}
